import { createContext, useContext, useState } from "react"

export type SignupData = {
  firstName?: string
  lastName?: string
  phone?: string
  email?: string
  promoCode?: string
  registryNumber?:
    | string
    | {
        first: string
        second: string
        number: string
      }
}

type SignupContextType = {
  signupData: SignupData
  setSignupData: (data: Partial<SignupData>) => void
}

const SignupContext = createContext<SignupContextType | undefined>(undefined)

export function SignupProvider({ children }: { children: React.ReactNode }) {
  const [signupData, setSignupDataState] = useState<SignupData>({})

  const setSignupData = (data: Partial<SignupData>) => {
    setSignupDataState((prev) => ({ ...prev, ...data }))
  }

  return (
    <SignupContext.Provider value={{ signupData, setSignupData }}>
      {children}
    </SignupContext.Provider>
  )
}

export function useSignup() {
  const ctx = useContext(SignupContext)
  if (!ctx) throw new Error("useSignup must be used within SignupProvider")
  return ctx
}
